import { render, staticRenderFns } from "./ContractSettingsModal.vue?vue&type=template&id=24ec646c&"
import script from "./ContractSettingsModal.vue?vue&type=script&lang=js&"
export * from "./ContractSettingsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports